module.exports = __webpack_public_path__ + "img/course_complete.4784b25e.svg";